// Version : 0.0.1
// Author : SATHISH
// LastEdit : SATHISH
// MODFIED DATE:19-09-2025
//Last ADD :CODE REVIEW CHANGES AND ADD VERSION
import { docodeHexResponse } from '../../_common/common.utils';
import productTypeActionTypes from './product-type.types';

const INITIAL_STATE = {
	addProductTypeDetailsResponse: null,
	updateProductTypeDetailsResponse: null,

	getProductTypeListResponse: null,
	getProductTypeListArr: [],

	fetchProductTypeDetailsResponse: null,
	fetchProductTypeDetailsArr: [],

	deleteProductTypeDetailsResponse: null,
};

const productTypeReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/*************** START ADD PRODUCT TYPE DETAILS ******************/
		case productTypeActionTypes.ADD_PRODUCT_TYPE_DETAILS_SUCCESS:
			return { ...state, addProductTypeDetailsResponse: action.payload };

		case productTypeActionTypes.ADD_PRODUCT_TYPE_DETAILS_FAILURE:
			return { ...state, addProductTypeDetailsResponse: action.payload };

		case productTypeActionTypes.ADD_PRODUCT_TYPE_DETAILS_RESPONSE_CHANGED:
			return { ...state, addProductTypeDetailsResponse: null };
		/*************** END ADD PRODUCT TYPE DETAILS ******************/

		/*************** START UPDATE PRODUCT TYPE DETAILS ******************/
		case productTypeActionTypes.UPDATE_PRODUCT_TYPE_DETAILS_SUCCESS:
			return { ...state, updateProductTypeDetailsResponse: action.payload };

		case productTypeActionTypes.UPDATE_PRODUCT_TYPE_DETAILS_FAILURE:
			return { ...state, updateProductTypeDetailsResponse: action.payload };

		case productTypeActionTypes.UPDATE_PRODUCT_TYPE_DETAILS_RESPONSE_CHANGED:
			return { ...state, updateProductTypeDetailsResponse: null };
		/*************** END UPDATE PRODUCT TYPE DETAILS ******************/

		/*************** START GET PRODUCT TYPE LIST ******************/
		case productTypeActionTypes.GET_PRODUCT_TYPE_LIST_SUCCESS:
			return {
				...state,
				getProductTypeListResponse: action.payload,
				getProductTypeListArr: docodeHexResponse(action.payload, 'GetProductTypeListKey'),
			};

		case productTypeActionTypes.GET_PRODUCT_TYPE_LIST_FAILURE:
			return { ...state, getProductTypeListResponse: action.payload };

		case productTypeActionTypes.GET_PRODUCT_TYPE_LIST_RESPONSE_CHANGED:
			return { ...state, getProductTypeListResponse: null };

		/*************** END GET PRODUCT TYPE LIST ******************/

		/*************** START FETCH PRODUCT TYPE DETAILS ******************/
		case productTypeActionTypes.FETCH_PRODUCT_TYPE_DETAILS_SUCCESS:
			return {
				...state,
				fetchProductTypeDetailsResponse: action.payload,
				fetchProductTypeDetailsArr: docodeHexResponse(
					action.payload,
					'FetchProductTypeDetailsKey',
				),
			};

		case productTypeActionTypes.FETCH_PRODUCT_TYPE_DETAILS_FAILURE:
			return { ...state, fetchProductTypeDetailsResponse: action.payload };

		case productTypeActionTypes.FETCH_PRODUCT_TYPE_DETAILS_RESPONSE_CHANGED:
			return {
				...state,
				fetchProductTypeDetailsResponse: null,
				fetchProductTypeDetailsArr: [],
			};
		/*************** END FETCH PRODUCT TYPE DETAILS ******************/

		/** ***************** DELETE PRODUCT TYPE DETAILS START *********************** */
		case productTypeActionTypes.DELETE_PRODUCT_TYPE_DETAILS_SUCCESS:
			return { ...state, deleteProductTypeDetailsResponse: action.payload };

		case productTypeActionTypes.DELETE_PRODUCT_TYPE_DETAILS_FAILURE:
			return { ...state, deleteProductTypeDetailsResponse: action.payload };

		case productTypeActionTypes.DELETE_PRODUCT_TYPE_DETAILS_RESPONSE_CHANGED:
			return { ...state, deleteProductTypeDetailsResponse: null };
		/** ***************** DELETE PRODUCT TYPE DETAILS END *********************** */

		default:
			return state;
	}
};

export default productTypeReducer;
